export default {
  // 邊上的文案
  edgeLabels: {
    addressOwnership: "地址歸屬",
    firstInflow: "首筆流入",
    total: "共",
    transactions: "筆交易",
  },
};
